var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { GridDataAutoCompleteHandler } from "@netdata/react-filter-box";
import { map, uniq, pipe, identity, path, flatten } from "ramda";
var FilterBoxAutocompleteHandler = /** @class */ (function (_super) {
    __extends(FilterBoxAutocompleteHandler, _super);
    function FilterBoxAutocompleteHandler(data, options, accessors, fieldValueGetters) {
        var _this = _super.call(this, data, options) || this;
        _this.accessorPaths = accessors || {};
        _this.fieldValueGetters = fieldValueGetters || {};
        return _this;
    }
    FilterBoxAutocompleteHandler.prototype.needValues = function (parsedCategory, parsedOperator) {
        var _this = this;
        var found = this.options.find(function (f) { return f.columnField == parsedCategory || f.columnText == parsedCategory; });
        if (found != null && found.type == "selection" && this.data != null) {
            var category_1 = found.columnField;
            var accessorPath_1 = this.accessorPaths[category_1];
            if (!this.cache[category_1]) {
                this.cache[category_1] = pipe(map(function (dataRow) {
                    var value = accessorPath_1 ? path(accessorPath_1, dataRow) : dataRow[category_1];
                    if (Array.isArray(value) && _this.fieldValueGetters[category_1]) {
                        return value.map(_this.fieldValueGetters[category_1]);
                    }
                    return value;
                }), flatten, uniq, identity)(this.data);
            }
            return this.cache[category_1];
        }
        if (found != null && found.customValuesFunc) {
            return found.customValuesFunc(parsedCategory, parsedOperator);
        }
        return [];
    };
    return FilterBoxAutocompleteHandler;
}(GridDataAutoCompleteHandler));
export { FilterBoxAutocompleteHandler };
